// import { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { IoMdClose } from "react-icons/io";
// import axios from "axios";
// import { apiurl } from "../config/config";

// const AssignRoleModal = ({ isModalOpen, setIsModalOpen , selectedApplications }) => {
//   const [selectedRole, setSelectedRole] = useState("");
//   const [selectedUsers, setSelectedUsers] = useState([]); // Store multiple users
//   const [users, setUsers] = useState([]);

//   // Fetch users by role when role changes
//   useEffect(() => {
//     if (selectedRole) {
//       fetchUsersByRole(selectedRole);
//     }
//   }, [selectedRole]);

//   const fetchUsersByRole = async (role) => {
//     try {
//       const response = await axios.post(
//         `${apiurl}/api/user/getbyrole`,
//         { role }, // Pass role in the request body
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
  
//       if (response.data.success) {
//         setUsers(response.data.users);
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   };
  
  
//   // Handle multi-user selection
//   const handleUserSelection = (userId) => {
//     setSelectedUsers((prevUsers) =>
//       prevUsers.includes(userId) ? prevUsers.filter((id) => id !== userId) : [...prevUsers, userId]
//     );
//   };

//   // Submit assigned role to selected users
//   const handleAssign = async () => {
//     if (selectedUsers.length === 0 || !selectedRole) {
//       alert("Please select at least one user and a role.");
//       return;
//     }

//     try {
//       const response = await axios.post(`${apiurl}/api/user/assignrole`, {
//         userIds: selectedUsers,
//         role: selectedRole,
//       });

//       if (response.data.success) {
//         alert("Role assigned successfully!");
//         setIsModalOpen(false);
//         setSelectedUsers([]); // Reset selection
//         setSelectedRole(""); // Reset role selection
//       }
//     } catch (error) {
//       console.error("Error assigning role:", error);
//       alert("Failed to assign role. Please try again.");
//     }
//   };

//   return (
//     isModalOpen && (
//       <div
//         className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center"
//         onClick={() => setIsModalOpen(false)}
//       >
//         <motion.div
//           initial={{ opacity: 0, y: -50 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: -50 }}
//           transition={{ duration: 0.3, ease: "easeOut" }}
//           className="bg-white p-6 rounded-2xl shadow-2xl w-96 relative"
//           onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
//         >
//           {/* Close Button */}
//           <button
//             className="absolute top-3 right-3 text-gray-500 hover:text-red-500"
//             onClick={() => setIsModalOpen(false)}
//           >
//             <IoMdClose size={20} />
//           </button>

//           {/* Modal Content */}
//           <h3 className="text-xl font-semibold mb-4 text-center">Assign Role</h3>

//           {/* Select Role */}
//           <select
//             className="w-full p-2 border rounded mb-3"
//             onChange={(e) => setSelectedRole(e.target.value)}
//             value={selectedRole}
//           >
//             <option value="">Select Role</option>
//             <option value="screener">Screener</option>
//             <option value="trainer">Trainer</option>
//             <option value="interviewer">Interviewer</option>
//             <option value="hr">HR</option>
//             <option value="user">User</option>
//           </select>

//           {/* Select Users (Multiple) */}
//           <div className="w-full p-2 border rounded mb-3">
//             <h4 className="text-sm font-semibold mb-2">Select Users:</h4>
//             {users.length === 0 ? (
//               <p className="text-gray-500">No users available for this role.</p>
//             ) : (
//               users.map((user) => (
//                 <label key={user._id} className="flex items-center gap-2 mb-2">
//                   <input
//                     type="checkbox"
//                     value={user._id}
//                     onChange={() => handleUserSelection(user._id)}
//                     checked={selectedUsers.includes(user._id)}
//                   />
//                   {user.firstName} {user.lastName}
//                 </label>
//               ))
//             )}
//           </div>

//           {/* Assign & Close Buttons */}
//           <button
//             className="w-full bg-green-500 text-white py-2 rounded mb-2 hover:bg-green-600"
//             onClick={handleAssign}
//           >
//             Assign
//           </button>
//           <button
//             className="w-full bg-red-500 text-white py-2 rounded hover:bg-red-600"
//             onClick={() => setIsModalOpen(false)}
//           >
//             Close
//           </button>
//         </motion.div>
//       </div>
//     )
//   );
// };

// export default AssignRoleModal;
import { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";
import { apiurl } from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AssignRoleModal = ({ isModalOpen, setIsModalOpen, selectedApplications }) => {
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedUser, setSelectedUser] = useState(""); // Single user selection
  const [users, setUsers] = useState([]);

  // Fetch users based on role
  useEffect(() => {
    if (selectedRole) {
      fetchUsersByRole(selectedRole);
    }
  }, [selectedRole]);

  const fetchUsersByRole = async (role) => {
    try {
      const response = await axios.post(`${apiurl}/api/user/getbyrole`, { role });

      if (response.data.success) {
        setUsers(response.data.users);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // Function to determine API endpoint based on role
  const getApiEndpoint = (role) => {
    switch (role) {
      case "screener":
        return "/api/application/assign/screener";
      case "interviewer":
        return "/api/application/assign/interviewer";
      case "trainer":
        return "/api/application/assign/trainer";
      default:
        return null;
    }
  };

  // Function to assign user to applications
  const handleAssign = async () => {
    if (!selectedUser || !selectedRole) {
      toast.error("Please select a user and a role.");
      return;
    }

    const apiEndpoint = getApiEndpoint(selectedRole);
    if (!apiEndpoint) {
      toast.error("Invalid role selected.");
      return;
    }

    try {
      const response = await axios.post(`${apiurl}${apiEndpoint}`, {
        screenerObjId: selectedUser,
        // applicationObjIds: ["67da9bc153ffc7d409af3651", "67da6b71b1530badb6a518ec"], // Replace with dynamic IDs
        applicationObjIds: selectedApplications
      });

      if (response.data.success) {
        toast.success("Role assigned successfully!");
        setTimeout(() => setIsModalOpen(false), 1500); // Close modal after success
      }
    } catch (error) {
      console.error("Error assigning role:", error);
      toast.error("Failed to assign role.");
    }
  };

  console.log("226 data get successfully",selectedApplications);

  return (
    isModalOpen && (
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        <div
          className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center"
          onClick={() => setIsModalOpen(false)}
        >
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="bg-white p-6 rounded-2xl shadow-2xl w-96 relative"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500"
              onClick={() => setIsModalOpen(false)}
            >
              <IoMdClose size={20} />
            </button>

            {/* Modal Content */}
            <h3 className="text-xl font-semibold mb-4 text-center">Assign Role</h3>

            {/* Select Role */}
            <select
              className="w-full p-2 border rounded mb-3"
              onChange={(e) => setSelectedRole(e.target.value)}
              value={selectedRole}
            >
              <option value="">Select Role</option>
              <option value="screener">Screener</option>
              <option value="interviewer">Interviewer</option>
              <option value="trainer">Trainer</option>
               <option value="hr">HR</option>
              <option value="user">User</option>
            </select>

            {/* Select User (Single Selection) */}
            <select
              className="w-full p-2 border rounded mb-3"
              onChange={(e) => setSelectedUser(e.target.value)}
              value={selectedUser}
              disabled={!users.length}
            >
              <option value="">Select User</option>
              {users.map((user) => (
                <option key={user._id} value={user._id}>
                  {user.firstName} {user.lastName}
                </option>
              ))}
            </select>

            {/* Assign & Close Buttons */}
            <button
              className="w-full bg-green-500 text-white py-2 rounded mb-2 hover:bg-green-600"
              onClick={handleAssign}
            >
              Assign
            </button>
            <button
              className="w-full bg-red-500 text-white py-2 rounded hover:bg-red-600"
              onClick={() => setIsModalOpen(false)}
            >
              Close
            </button>
          </motion.div>
        </div>
      </>
    )
  );
};

export default AssignRoleModal;